import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import * as S from "./SeoPage.styles";
import SeoSearchHeader from "../SearchPage/components/ModifySearchHeader/ModifySearchHeaderUI";
import SeoPageHeader from "./containers/SeoPageHeader/SeoPageHeaderUI";
import SeoContainer from "./containers/SeoContainer/SeoContainer";
import SeoInterLinking from "./containers/SeoInterLinking/SeoInterLinking";
import Filter from '../../containers/Filter/Filter';
import Listing from './containers/Listing/Listing';
import AirportTripSelector from '../../../stories/components/cars/SeoPage/AirportTripSelector/AirportTripSelector';
import { pageView } from "../../config/ga";
import { lobDataSelector, SeoMetaSelector, showSEOLeadgenSelector, waySelector } from './redux/selector';
import { gcAirportCitySEOScreen, getLoadedComponent } from "../../config/omni";
import { AirportPageComp } from "../../utils/util-constants";
import LeadGenButton from "./containers/LeadGenButton/LeadGenButton";
import { getTravellerInformation } from "../Homepage/redux/thunks";
import { travellerDetailsCalledSelector } from '../Homepage/redux/selector';

export default function AirportPage() {
  const showLOBComponents = useSelector(lobDataSelector);
  const way = useSelector(waySelector);
  const seoMeta = useSelector(SeoMetaSelector);
  const showSEOLeadgen = useSelector(showSEOLeadgenSelector);
  const travellerDetailsCalled = useSelector(travellerDetailsCalledSelector);
  const [isPageViewCalled, setIsPageViewCalled] = useState(false);
  const dispatch = useDispatch();
  
  useEffect(() => {
    try {
      getLoadedComponent(AirportPageComp)
      dispatch(getTravellerInformation())
    } catch (e) {
      console.log("error", e);
    }
  }, []);

  useEffect(() => {
    if (travellerDetailsCalled && !isPageViewCalled) {
      setIsPageViewCalled(true)
      dispatch(pageView(gcAirportCitySEOScreen))
    }
  }, [travellerDetailsCalled, isPageViewCalled])

  return (
    <S.SeoWrapper>
      <SeoSearchHeader isSeo />
      <S.PageHeader>
        <SeoPageHeader />
      </S.PageHeader>
      <S.SeoPageWrapper>
        <S.PageRight>
          <AirportTripSelector way={way} slug={seoMeta?.canonical_url} reverseSlug={seoMeta?.reverse_slug} />
          {!showLOBComponents && <Listing />}
          <SeoContainer />
          <SeoInterLinking />
        </S.PageRight>
        <S.PageLeft>
          {!showLOBComponents && <Filter isSeo />}
        </S.PageLeft>
      </S.SeoPageWrapper>
      {showSEOLeadgen ? <LeadGenButton /> : null}
    </S.SeoWrapper>
  );
}
